import React, { useState } from "react";
import {FaDiscord, FaTwitter} from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import styled from "styled-components";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Nav>
      <Logo href="https://attractivebeasts.com/">
          <StyledImgg alt={"attractive beast gif"} src={"/config/images/attractivebeast.gif"} /> 
           {/* Attractive Beast */}
      </Logo>
      <Hamburger  onClick={() => setIsOpen(!isOpen)}>
        <span  />
        <span />
        <span />
      </Hamburger>
      <Menu isOpen={isOpen}>
                <MenuLink target="_blank" href="https://www.instagram.com/attractivebeasts/"><RiInstagramFill/></MenuLink>
                <MenuLink  target="_blank" href="https://twitter.com/AttractiveBeas1"><FaTwitter/></MenuLink>
                <MenuLink target="_blank" href="https://discord.com/invite/dzfVyxxfwJ"><FaDiscord/></MenuLink>
           < a target="_blank" href="https://opensea.io/collection/attractivebeasts-1" className="os">View On Opensea</a>
      </Menu>
      
    </Nav>
  );
};

export default Navbar;

export const Button = styled.button`
`;
export const StyledImgg = styled.img`
//   box-shadow: 0px 0px 21px 21px #ebc9089d;
  // box-shadow: 0px 0px 21px 21px rgba(241, 127, 190, 0.6);
  background-color: var(--accent);
  border-radius: 100%;
  width: 70px;
  height:70px;
//   @media (min-width: 900px) {
//     width: 250px;
//   }
//   @media (min-width: 1000px) {
//     width: 300px;
//   }
  transition: width 0.5s;
`;

const MenuLink = styled.a`
  padding: 1rem 2rem;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  transition: all 0.3s ease-in;
  font-size: 3.1rem;
  color:#fff;
  font-size: 2.3rem;
  @media (max-width: 768px) {
    padding: 2rem 2rem;
    font-size:2rem;
  }

  &:hover {
    color: var(--alice);
    font-size:2.5rem;
    
  }
`;

const Nav = styled.div`
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  background: transparent;
  margin-bottom:5rem;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  @media (max-width: 768px) {

  }
`;

const Logo = styled.a`
  padding: 1rem 0;
  color: #7b7fda;
  text-decoration: none;
  font-weight: 800;
  font-size: 1.7rem;
  @media (max-width: 768px) {

    font-size:1rem;
  }
  span {
    font-weight: 300;
    font-size: 1.3rem;
  }
`;

const Menu = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  @media (max-width: 768px) {
    overflow: hidden;
    flex-direction: column;
    max-height: ${({ isOpen }) => (isOpen ? "100vh" : "0")};
    transition: max-height 0.3s ease-in;
    width: 100%;
   background-color:var(--pink);
   padding:0;
   margin:0;
   z-index:99;
   position: absolute;
   
   height:100vh;
  top: 0;
  left: 0;
  right: 0;
        
  }
`;

const Hamburger = styled.div`
display: none;
  flex-direction: column;
  cursor: pointer;
  span {
    height: 2px;
    width: 25px;
    background: #7b7fda;
    margin-bottom: 4px;
    border-radius: 5px;
  }
  @media (max-width: 768px) {
    display: flex;
    z-index:9999;
  }
  
  
`;